// @flow
import TextField from "@mui/material/TextField";
import React from 'react';
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import type {Exhibition} from "../../../../../../types/exhibition/types";
import {useTranslation} from "react-i18next";
import {EXHIBITION} from "../../../../../../locales/components/namespaces";
import {Update} from "../../../../../../hooks/exhibitions/useExhibitionAction";
import MenuItem from "@mui/material/MenuItem";
import {
    CatalogueLanguages,
    DefaultLanguages,
    ExhibitionLanguages,
    GeneralLanguages
} from "../../../../../../helpers/constants";
import Select from "@mui/material/Select";

type Props = {
    id: string,
    exhibition: Exhibition,
    updateExhibition: Function
};

const DefaultLanguage = (props: Props) => {
    const {t} = useTranslation(EXHIBITION)
    const {id, exhibition, updateExhibition} = props
    
    const onChange = (value) => {
        updateExhibition(id, value, Update.DefaultLanguage)
    }
    
    return (
        <ListItem>
            <ListItemText
                primary={t('General Language')}
                secondary={t('Select displayed language.')}
            />
            <TextField
                select
                name={"badgeTemplateTypeId"}
                value={exhibition.defaultLanguage}
                onChange={(evt) => onChange(evt.target.value)}
                // label={t('Print Size')}
                sx={{minWidth: '220px'}}
                size={"small"}
                variant={'filled'}
                slotProps={{
                    inputLabel: {
                        shrink: true,
                    },
                }}
            >
                <MenuItem
                    value={DefaultLanguages.EN}
                >
                    {t('English')}
                </MenuItem>
                <MenuItem
                    value={DefaultLanguages.EL}
                >
                    {t('Greek')}
                </MenuItem>
            </TextField>
        </ListItem>
    );
};

export default DefaultLanguage